/**
 * Flexão ilustrativa do pescoço: o cinto contém o tronco e a cabeça continua à frente (flexão);
 * depois recua parcialmente e, no empurrão do encosto, fica para trás (extensão). Ângulo relativo
 * ao tronco, em radianos, positivo para a frente. Não prevê lesão cervical.
 */
export const FLEXAO_PESCOCO_MAX = 0.5
const limitar01 = (v: number) => Math.max(0, Math.min(1, Number.isFinite(v) ? v : 0))

export function anguloPescoco(corpo: number, orgaos: number, objeto: number) {
  return FLEXAO_PESCOCO_MAX * limitar01(corpo) * (1 - 0.4 * limitar01(orgaos)) - 0.2 * limitar01(objeto)
}
